var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgV1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 66,
    viewBox: "0 0 115 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.5942 35.0441L52.6725 30.0898C54.7999 26.6546 55.8608 24.939 57.9057 23.981C59.9451 23.019 62.5232 23.019 67.6904 23.019H69.9716C75.1388 23.019 77.7224 23.019 79.7618 23.981C81.8067 24.943 82.8676 26.6546 85.0005 30.0898L88.0733 35.0441M96.3188 35.0441H44.8723C39.5072 35.0441 34.1201 38.4511 29.6895 40.291C27.8041 41.0726 26.8641 41.4614 25.9956 41.3412C25.1325 41.2209 24.231 40.4553 22.4225 38.9321C18.657 35.7415 14.5783 35.0441 8.36664 35.0441C5.33229 35.0441 2.86963 37.1364 2.86963 39.7218V58.4247C2.86963 61.0101 5.33229 63.1024 8.36664 63.1024C14.5728 63.1024 18.6515 62.405 22.428 59.2143C24.231 57.6912 25.1325 56.9296 26.0011 56.8093C26.8641 56.6851 27.8041 57.0779 29.684 57.8595C34.1256 59.6953 39.5127 63.1024 44.8778 63.1024H96.3188C105.427 63.1024 112.81 56.8214 112.81 49.0732C112.81 41.3251 105.427 35.0441 96.3188 35.0441Z",
    stroke: "#C49A6C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8339 23.0185V6.98514C68.8339 5.92207 69.413 4.90253 70.4439 4.15082C71.4748 3.39911 72.873 2.97681 74.3309 2.97681H79.8279",
    stroke: "#C49A6C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgV1);
export default __webpack_public_path__ + "static/media/V1.11b7fb360132c1675bc3e2fe77625ae2.svg";
export { ForwardRef as ReactComponent };